<template>
  <div :class="{'show':show}" class="header-search">
    <el-button class="searchBtn" icon="el-icon-search" @click="click"/>
    <el-select
      ref="headerSearchSelect"
      v-model="search"
      :remote-method="querySearch"
      filterable
      default-first-option
      remote
      :placeholder="$t('navbar.menu_search')"
      class="header-search-select"
      @change="change"
      @focus="clear">
      <el-option v-for="item in options" :key="item.path" :value="item" :label="item.title.join(' > ')"/>
    </el-select>
  </div>
</template>
<script>
import Fuse from 'fuse.js'
import path from 'path'
import { i18n } from '@/lang'
export default {
  name: 'HeaderSearch',
  data() {
    return {
      search: '',
      options: [],
      searchPool: [],
      show: true,
      fuse: undefined
    }
  },
  computed: {
    routers() {
      return this.$store.getters.permission_routers
    },
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    lang() {
      this.searchPool = this.generateRouters(this.routers)
    },
    routers() {
      this.searchPool = this.generateRouters(this.routers)
    },
    searchPool(list) {
      this.initFuse(list)
    },
    show(value) {
      if (value) {
        document.body.addEventListener('onclick', this.close)
      } else {
        document.body.removeEventListener('onclick', this.close)
      }
    }
  },
  mounted() {
    this.searchPool = this.generateRouters(this.routers)
  },
  methods: {
    // 每次获得焦点时，清空一下
    clear () {
      this.search = ''
      this.options = []
    },
    click() {
      this.show = !this.show
      if (this.show) {
        this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus()
      }
    },
    close() {
      this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur()
      this.options = []
      this.show = false
    },
    change(val) {
      this.$router.push(val.path)
      this.search = ''
      this.options = []
      this.$nextTick(() => {
        this.show = false
      })
    },
    initFuse(list) {
      this.fuse = new Fuse(list, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [{
          name: 'title',
          weight: 0.7
        }, {
          name: 'path',
          weight: 0.3
        }]
      })
    },
    // Filter out the routes that can be displayed in the sidebar
    // And generate the internationalized title
    generateRouters(routers, basePath = '/', prefixTitle = []) {
      let res = []

      for (const router of routers) {
        // skip hidden router
        if (router.hidden) { continue }
        const data = {
          path: path.resolve(basePath, router.path),
          title: [...prefixTitle]
        }

        if (router.meta && router.meta.title) {
          // generate internationalized title
          // 国际化之后再放开
          const i18ntitle = i18n.t(`route.${router.meta.title}`)
          // const i18ntitle = router.meta.title
          data.title = [...data.title, i18ntitle]

          if (router.redirect) {
            // only push the routes with title
            // special case: need to exclude parent router without redirect
          } else {
            res.push(data)
          }
        }

        // recursive child routers
        if (router.children) {
          const tempRouters = this.generateRouters(router.children, data.path, data.title)
          if (tempRouters.length >= 1) {
            res = [...res, ...tempRouters]
          }
        }
      }
      return res
    },
    querySearch(query) {
      if (query !== '') {
        this.options = this.fuse.search(query)
      } else {
        this.options = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-search {
  font-size: 0 !important;

  .search-icon {
    cursor: pointer;
    font-size: 18px;
    vertical-align: middle;
  }

  .header-search-select {
    font-size: 18px;
    transition: width 0.2s;
    width: 0;
    overflow: hidden;
    background: transparent;
    border-radius: 0;
    display: inline-block;
    vertical-align: middle;

    /deep/ .el-input__inner {
      border-radius: 5px;
      border: 0;
      padding-left: 4px;
      padding-right: 0;
      box-shadow: none !important;
      vertical-align: middle;
    }
  }

  &.show {
    .header-search-select {
      width: 210px;
      margin-left: 10px;
    }
  }
}
.searchBtn{
  border: 0;
  position: relative;
  top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderSearch/index.vue